
export default function RemoteControl({
  setQuestionNbr,
  isAudioFinished,
  chosenAnswers,
  dispatchAnswers,
  questionNbr,
  correctAnswer
}) {
  let answers = JSON.parse(sessionStorage.getItem("__users_answers__"))?.[
    questionNbr - 1
  ];

  const AnswerScreen = ({ nbr }) => {
    return (
      <span style={{ color: correctAnswer && "green" }}>
        {correctAnswer ? (
          correctAnswer.includes(nbr) ? (
            nbr
          ) : (
            <hr />
          )
        ) : chosenAnswers[nbr] ? (
          chosenAnswers[nbr]
        ) : (
          <hr />
        )}{" "}
      </span>
    );
  };
  const AnswerButton = ({ nbr }) => {
    return (
      <button
        className="remote-numeric-btn fsize"
        style={{
          background: correctAnswer?.includes(nbr)
            ? "radial-gradient(#7cad53, #35842f)"
            : (chosenAnswers[nbr] || answers?.[nbr]) &&
              "radial-gradient(#e2212d, #762325,#570e0f)",
        }}
        onClick={() => !correctAnswer && dispatchAnswers({ type: nbr })}
      >
        {nbr}
      </button>
    );
  };
  return (
    <div id="remote-outer">
      <div id="remote">
        <div id="remote-screen">
          <AnswerScreen nbr={1} />
          <AnswerScreen nbr={2} />
          <AnswerScreen nbr={3} />
          <AnswerScreen nbr={4} />
        </div>
        <div id="remote-body">
          <button
            id="remote-corriger-btn"
            className="remote-string-btn"
            onClick={() => dispatchAnswers({ type: "reset" })}
          >
           <div>Corriger</div>تصحيح
          </button>
          <AnswerButton nbr={1} />
          <AnswerButton nbr={2} />
          <AnswerButton nbr={3} />
          <AnswerButton nbr={4} />
          <button
            id="remote-valider-btn"
            className="remote-string-btn"
            onClick={() => {
              dispatchAnswers({ type: "validate" });
              setQuestionNbr((n) => n + 1);
            }}
            // disabled={!isAudioFinished || correctAnswer}
            // style={{
            //   background:
            //     (!isAudioFinished || correctAnswer) &&
            //     "radial-gradient(#7782a9, #2d3870, #1d234d)",
            // }}
          >
            <div>Valider</div>موافق
          </button>
        </div>
      </div>
    </div>
  );
}
